var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_2687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 12.0462C18.447 12.0462 18 12.4943 18 13.0461V21.0462C18 21.5972 17.5519 22.0461 17.0001 22.0461H3C2.44794 22.0461 2.00006 21.5972 2.00006 21.0462V7.04614C2.00006 6.49518 2.44794 6.0462 3 6.0462H11.0001C11.553 6.0462 12 5.59814 12 5.04626C12 4.4942 11.553 4.04614 11.0001 4.04614H3C1.34601 4.04614 0 5.39215 0 7.04614V21.0462C0 22.7002 1.34601 24.0462 3 24.0462H17.0001C18.6541 24.0462 20.0001 22.7002 20.0001 21.0462V13.0461C20.0001 12.4932 19.5529 12.0462 18.9999 12.0462Z",
    fill: "#0E60B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37588 11.1351C9.30594 11.2051 9.25888 11.2941 9.23892 11.39L8.53195 14.9261C8.49899 15.09 8.55099 15.259 8.66891 15.3781C8.76394 15.4731 8.89194 15.524 9.02304 15.524C9.0549 15.524 9.08804 15.5211 9.121 15.5141L12.656 14.8071C12.754 14.787 12.843 14.7401 12.912 14.67L20.824 6.758L17.289 3.22314L9.37588 11.1351Z",
    fill: "#0E60B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2678 0.778152C22.293 -0.196884 20.7069 -0.196884 19.7328 0.778152L18.3489 2.16206L21.8839 5.6971L23.2678 4.313C23.7399 3.84206 23.9999 3.214 23.9999 2.54604C23.9999 1.87807 23.7399 1.25002 23.2678 0.778152Z",
    fill: "#0E60B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_2687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.294b8fa0446b72a70598e12fb5efc33b.svg";
export { ForwardRef as ReactComponent };